import './AppHeader.css';
import * as React from "react";
import PropTypes from "prop-types";

AppHeader.propTypes = {
    title: PropTypes.string.isRequired,
}

export default function AppHeader(props) {
    return (
        <header className="app-header">
            <div className="left-header">Offerte aanvraag</div>
            <div className="right-header">{props.title}</div>
        </header>
    );
}
